module.exports = __webpack_public_path__ + "static/media/heroBannerImageMobile.fbe3d5d2.webp";